export default __webpack_public_path__ + "static/media/smile.624932a8.jpg";